// removed by extract-text-webpack-plugin
module.exports = {"select-days-in-week":"select-days-in-week","select-day":"select-day","selected":"selected","box-style":"box-style","select-list":"select-list"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/SelectDaysInWeek/SelectDaysInWeekField.scss
// module id = rrch
// module chunks = 0